import { render, staticRenderFns } from "./cargoCompanySelect.vue?vue&type=template&id=562596a2&"
import script from "./cargoCompanySelect.vue?vue&type=script&lang=js&"
export * from "./cargoCompanySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('562596a2')) {
      api.createRecord('562596a2', component.options)
    } else {
      api.reload('562596a2', component.options)
    }
    module.hot.accept("./cargoCompanySelect.vue?vue&type=template&id=562596a2&", function () {
      api.rerender('562596a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/standard/cargoCompanySelect.vue"
export default component.exports